/** @format */
import angular from 'angular';
import _ from 'lodash';
import { localeServiceModule } from 'sis-common';
import { errorServiceModule } from '../error-handler/legacy/errorService';
import { dropdownSelectModule } from '../select/dropdownSelect.component';
import { publicPersonServiceModule } from '../service/publicPerson.service';
import personTitleSelectorTpl from './personTitleSelector.tpl.html';

personTitleSelectorController.$inject = ['$translate', 'publicPersonService', 'localeService', 'defaultPromiseHandler'];

export const personTitleSelectorModule = 'sis-components.person.personTitleSelector';
/**
 * @Deprecated
 * upgraded to PersonTitleSelectorComponent in lib/person/person-title-selector/person-title-selector.component.ts
 */
angular
    .module(personTitleSelectorModule, [
        'pascalprecht.translate',
        errorServiceModule,
        publicPersonServiceModule,
        dropdownSelectModule,
        localeServiceModule,
    ])
    .component('personTitleSelector', {
        template: personTitleSelectorTpl,
        bindings: {
            additionalInfo: '<',
            personId: '<',
            // The initial title. If defined then this component will preselect one of persons titles for dropdown if any matches, otherwise
            // this will set initial title to custom title. This argument could be modified (and renamed to 'title') so that changes to
            // argument are dynamically reflected on the view but there was no need for that at the moment. In other words this component
            // does not listen to external modifications of this argument.
            initTitle: '<',
            required: '<?',
            disabled: '<?',
            onChange: '&',
            locales: '<?',
            dropdownAdditionalClasses: '@',
            onError: '&?',
        },
        transclude: {
            titleHelp: '?titleHelp',
            customTitleHelp: '?customTitleHelp',
        },
        controller: personTitleSelectorController,
    });

function personTitleSelectorController($translate, publicPersonService, localeService, defaultPromiseHandler) {
    const ctrl = this;

    // Special value in the dropdown that enables entering a custom title
    const customTitleSelection = _.mapValues({ fi: '', sv: '', en: '' }, (value, key) =>
        $translate.instant('SIS_COMPONENTS.PERSON.TITLE_CUSTOM', {}, _, key),
    );
    const customTitleLabel = localeService.getLocalizedValue(customTitleSelection);

    // Current selection in the dropdown
    ctrl.selectedTitle = null;
    // Custom title entered by the user
    ctrl.customTitle = null;

    ctrl.$onInit = () => {
        if (ctrl.initTitle) {
            if (!ctrl.personId) {
                ctrl.titles = [
                    {
                        value: customTitleSelection,
                        label: customTitleLabel,
                    },
                ];
                ctrl.customTitle = ctrl.initTitle;
                ctrl.selectedTitle = customTitleSelection;
                return;
            }
            publicPersonService
                .findById(ctrl.personId)
                .then(person => {
                    const title = _.find(_.get(person, 'titles'), ctrl.initTitle);
                    if (title) {
                        ctrl.selectedTitle = title;
                    } else if (person) {
                        ctrl.customTitle = ctrl.initTitle;
                        ctrl.selectedTitle = customTitleSelection;
                    }
                })
                .catch(defaultPromiseHandler.loggingRejectedPromiseHandler);
        }
    };

    ctrl.$onChanges = function (changes) {
        if (changes.personId) {
            publicPersonService.findById(changes.personId.currentValue).then(
                person => {
                    if (person) {
                        ctrl.titles = _.chain(person.titles)
                            .map(title => ({
                                value: title,
                                label: localeService.getLocalizedValue(title),
                            }))
                            .filter(option => !!option.label)
                            .value()
                            .concat({
                                value: customTitleSelection,
                                label: customTitleLabel,
                            });
                    } else {
                        clear();
                    }
                },
                () => {
                    clear();
                },
            );
        } else if (changes.additionalInfo && !_.isEmpty(changes.additionalInfo.currentValue) && !ctrl.personId) {
            ctrl.titles = [
                {
                    value: customTitleSelection,
                    label: customTitleLabel,
                },
            ];
        } else if (changes.additionalInfo && _.isEmpty(changes.additionalInfo.currentValue) && !ctrl.personId) {
            clear();
        }
    };

    ctrl.handleChange = function () {
        if (_.isFunction(ctrl.onChange)) {
            ctrl.onChange({ title: ctrl.isCustomTitleSelected() ? ctrl.customTitle : ctrl.selectedTitle });
        }
    };

    ctrl.selectTitle = function (title) {
        ctrl.selectedTitle = title;
        ctrl.handleChange();
    };

    ctrl.getLabelState = function () {
        if (ctrl.required && (_.isEmpty(ctrl.selectedTitle) || (ctrl.isCustomTitleSelected() && _.isEmpty(ctrl.customTitle)))) {
            return 'required';
        }
        if (!_.isEmpty(ctrl.selectedTitle) && (!ctrl.isCustomTitleSelected() || !_.isEmpty(ctrl.customTitle))) {
            return 'valid';
        }

        return '';
    };

    ctrl.isCustomTitleSelected = function () {
        return _.isEqual(ctrl.selectedTitle, customTitleSelection);
    };

    function clear() {
        delete ctrl.titles;
        delete ctrl.customTitle;

        // Notify the parent component
        ctrl.selectTitle(null);
    }
}
